import React from 'react';
import BaseTablePage from '../../elements/BaseTablePage'
import Pagination from '../../elements/Pagination'


import { TaskTableUI } from './TaskTableUI'
import {TaskSearchForm} from './TaskSearchForm'

//import { GhorePrizePage } from '../../components/GhorePrizePage'


export class TaskTable extends BaseTablePage {

  constructor(props) {
    super(props);
    this.getDataUrl = "api/v1/GetTask?offset=";
    this.getExcelUrl = "/api/v1/GetTaskExcel";

  

    this.className = "ChanceReport";
    this.state.mode = "table";
    this.state.searchData = { };

    this.autoRefresh=true;
  }


  render() {


    return (
      <div className="container">

        <TaskSearchForm onSubmit={this.onSubmitSearchData} searchData={this.state.searchData} />
        <br/>
        <TaskTableUI data={this.state.data} onViewClick={this.onViewClick} />
        <Pagination pageNumber={this.state.pageNumber} count={this.state.count} perPageCount={this.state.pageSize} onChange={this.handleChangePage} />
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/tables/task/TaskTable.js